import { action, observable, runInAction, makeObservable } from 'mobx';


// Holds the [currentTilikausi] variable, so that [tulosStore], [tasevastattavaaStore] and [tasevastaavaaStore] can access it.
class TilikausiStore {
    @observable currentTilikausi = null;

    constructor() {
        makeObservable(this);
    }
    @action.bound
    selectTilikausi(tilikausi) {
        runInAction(() => {
            this.currentTilikausi = tilikausi;
        });
    }
}

export default new TilikausiStore();